








import Vue from 'vue';
import PartyMaker from './components/PartyMaker.vue';

export default Vue.extend({
  name: 'App',

  components: {
    PartyMaker,
  },

  data: () => ({
    //
  }),
});
